(() => {
  if (document.documentElement.lang !== 'es') return;

  const rootSelector = '#xb-quantity-breaks-root';
  const observed = new WeakSet();
  const translations = new Map([
    ['buy more & save more', 'Compra más y ahorra más'],
    ['most popular', 'Más popular'],
    ['powered by', 'Desarrollado por'],
  ]);

  const translate = (text) => {
    const value = text.trim();
    let label = translations.get(value.toLowerCase());
    if (!label && /^Buy\s+\d+$/i.test(value)) label = value.replace(/^Buy/i, 'Compra');
    if (!label && /^Save\s+\S/i.test(value)) label = value.replace(/^Save/i, 'Ahorra');
    if (!label && /^Only\s+.+\s+per item$/i.test(value)) {
      label = value.replace(/^Only\s+(.+)\s+per item$/i, 'Solo $1 por unidad');
    }
    return label ? text.replace(value, () => label) : text;
  };

  const localize = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script, style, textarea')) continue;
      const translated = translate(node.data);
      // Keep the app's text nodes and controls intact during its rerenders.
      if (translated !== node.data) node.data = translated;
    }
    root.querySelectorAll('[aria-label], [title]').forEach((element) => {
      ['aria-label', 'title'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const translated = translate(value);
        if (translated !== value) element.setAttribute(attribute, translated);
      });
    });
  };

  const init = () => {
    document.querySelectorAll('.main-product__purchase').forEach((purchase) => {
      if (observed.has(purchase)) return;
      observed.add(purchase);
      const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title'] };
      const update = () => {
        observer.disconnect();
        purchase.querySelectorAll(rootSelector).forEach(localize);
        observer.observe(purchase, options);
      };
      // XBoost mounts asynchronously and replaces text when the variant or tier changes.
      const observer = new MutationObserver(update);
      update();
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
